/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable */
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Box, CssBaseline } from '@mui/material';
import GlobalStyle from 'modules/common/style/global';
import { Footer, Navbar, SessionTimeOutPopup, TokenRevokedPopup } from 'modules/common/components';
import useUpdateToken from 'modules/common/hooks/use-update-token';
import Sidebar from 'modules/common/components/sidebar/side-bar';
import getDashboardItems from 'modules/common/components/sidebar/dashboard-Items';
import { useSelector } from 'react-redux';
import { selectAccessToken } from 'modules/common/auth/selectors';
import { drawerWidth, Root, Drawer, AppContent, MainContent } from './style';
import useUpdatePbiToken from 'modules/common/hooks/use-update-pbi-token';
//
const DashboardLayout = ({ children }) => {
  useUpdatePbiToken();
  useUpdateToken();
  const accessToken = useSelector(selectAccessToken);
  //
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />

      <Drawer>
        <Box sx={{ display: { xs: 'block', lg: 'none' } }}>
          <Sidebar
            PaperProps={{ style: { width: drawerWidth } }}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            items={getDashboardItems(accessToken)}
          />
        </Box>
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <Sidebar
            PaperProps={{ style: { width: drawerWidth } }}
            items={getDashboardItems(accessToken)}
          />
        </Box>
      </Drawer>
      <AppContent>
        <Navbar onDrawerToggle={handleDrawerToggle} />
        <MainContent p={isLgUp ? 12 : 5}>
          {children}
          <Outlet />
          <SessionTimeOutPopup />
          <TokenRevokedPopup />
        </MainContent>
        <Footer />
      </AppContent>
    </Root>
  );
};

export default DashboardLayout;
